import CircularProgress from '@mui/material/CircularProgress'
import { useCurrentId } from 'features/messaging/hooks'
import { memo, type MutableRefObject } from 'react'
import { useIntersectionObserver } from 'shared/hooks'

import { api } from '../../api.ts'
import css from './Chat.module.css'

function LoadPrevious_({
	cursor,
	scrollableRef
}: {
	cursor: string
	scrollableRef: MutableRefObject<HTMLDivElement | null>
}) {
	const [chatSpinner, entry] = useIntersectionObserver({
		root: scrollableRef.current
	})
	const conversation = useCurrentId()
	const query = api.useMessagesPrevQuery(
		{ id: conversation, prevCursor: cursor },
		{
			skip: !(cursor && entry?.isIntersecting)
		}
	)

	if (query.isError) {
		return null
	}

	if (!query.isSuccess) {
		return (
			<div className={css.prev} ref={chatSpinner}>
				<CircularProgress
					classes={{ colorPrimary: 'material-loader' }}
					color='primary'
					size={20}
				/>
			</div>
		)
	}

	if (query.isSuccess && query.currentData?.prevCursor) {
		return (
			<LoadPrevious_
				cursor={query.currentData.prevCursor}
				scrollableRef={scrollableRef}
			/>
		)
	}

	return null
}

export const LoadPrevious = memo(LoadPrevious_)
